import {NgModule} from '@angular/core';
import {ProposalCellViewModule} from '@aztrix/components/row-cell-view';
import {TranslatePipe} from '@aztrix/translate';

import {SelectSearchModule} from '../select-search/select-search.module';
import {ProposalSelectSearchComponent} from './proposal-select-search.component';
import {HelperPipesModule} from '@aztrix/helpers';

@NgModule({
  declarations: [ProposalSelectSearchComponent],
  imports: [SelectSearchModule, ProposalCellViewModule, HelperPipesModule, TranslatePipe],
  exports: [ProposalSelectSearchComponent],
})
export class ProposalSelectSearchModule {}
